import { Controller } from "@hotwired/stimulus"

// Contrôle les champs spécifiques au type dans le formulaire de question de quiz.
// Changer le type (via boutons) affiche les champs correspondants et met à jour
// l'état actif du badge cliqué.
export default class extends Controller {
  static targets = ["typeInput", "panel", "typeButton"]

  static activeClasses = [ "border-blue-500", "bg-blue-50", "text-blue-700", "font-semibold" ]
  static inactiveClasses = [ "border-gray-300", "hover:bg-gray-50" ]

  connect() {
    this.showCurrentType()
  }

  switchType(event) {
    event.preventDefault()
    const newType = event.currentTarget.dataset.typeValue
    this.typeInputTarget.value = newType
    this.showCurrentType()
  }

  showCurrentType() {
    const currentType = this.typeInputTarget.value
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.typeValue !== currentType
    })
    this.typeButtonTargets.forEach((button) => {
      const isActive = button.dataset.typeValue === currentType
      button.classList.toggle("border-blue-500", isActive)
      button.classList.toggle("bg-blue-50", isActive)
      button.classList.toggle("text-blue-700", isActive)
      button.classList.toggle("font-semibold", isActive)
      button.classList.toggle("border-gray-300", !isActive)
      button.classList.toggle("hover:bg-gray-50", !isActive)
    })
  }
}
